import { LearningItem } from '../../models/LearningItem'

export default function learningItemUserAssignments(learningItem: LearningItem) {
  const users = learningItem.userLearningAssignments?.map((a) => a.user).filter((a) => !!a) || []

  if (users.length === 0) {
    return []
  }

  const uniqueMap = new Map(users.map((user) => [user!.uuid, user]))
  const uniqueUsers = Array.from(uniqueMap.values())

  uniqueUsers.sort((a, b) => {
    if (a!.firstname < b!.firstname) return -1
    if (a!.firstname > b!.firstname) return 1
    return 0
  })

  return uniqueUsers
}

export function learningItemUserAssignmentsByOtherUser(learningItem: LearningItem) {
  const users = learningItem.userLearningAssignments
    ?.filter((a) => a.assignedByUserUuid !== null)
    .map((a) => a.user)
    .filter((a) => !!a) || []

  if (users.length === 0) {
    return []
  }

  const uniqueMap = new Map(users.map((user) => [user!.uuid, user]))
  const uniqueUsers = Array.from(uniqueMap.values())

  uniqueUsers.sort((a, b) => {
    if (a!.firstname < b!.firstname) return -1
    if (a!.firstname > b!.firstname) return 1
    return 0
  })

  return uniqueUsers
}

export function isUserAssignedToLearningItem(userUuid: string, learningItem: LearningItem) {
  return learningItem.userLearningAssignments?.some((a) => a.userUuid === userUuid) || false
}

export function isUserAssignedToLearningItemByHimself(userUuid: string, learningItem: LearningItem) {
  return (
    learningItem.userLearningAssignments?.some((a) => a.userUuid === userUuid && a.assignedByUserUuid === userUuid) ||
    false
  )
}
